// extracted by mini-css-extract-plugin
export var boxItems = "_2c-1";
export var boxItemsLg = "_2c-2";
export var button = "_2c-7";
export var buttonHoverless = "_2c-9";
export var buttonLg = "_2c-8";
export var filterGroupBox = "_2c-0";
export var icon = "_2c-3";
export var iconSecondary = "_2c-6";
export var iconWrapper = "_2c-4";
export var iconWrapperLg = "_2c-5";
export var truncatedLabel = "_2c-a";